<template>
    <b-modal
        v-model="modalVisible"
        size="md"
        header-bg-variant="dark"
        header-text-variant="light"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        >
        <template v-slot:modal-title>
            <div class="pb-2">IMPORTAR INVITACIONES DESDE EXCEL</div>
        </template>

        <!-- Paso 1: Subir archivo -->
        <div v-if="currentStep === 'upload'">
            <b-row>
                <b-col cols="12">
                    <p class="font-weight-medium">Seleccione el archivo Excel con los NITs a invitar:</p>
                </b-col>
                <b-col cols="12">
                    <b-form-file
                        v-model="selectedFile"
                        placeholder="Seleccione o arrastre un archivo..."
                        drop-placeholder="Suelte el archivo aquí..."
                        accept=".xlsx, .xls, .csv"
                        :state="Boolean(selectedFile)"
                    ></b-form-file>
                    <div class="mt-2">
                        <small class="text-muted">El archivo debe tener una sola columna con el NIT.</small>
                    </div>
                </b-col>
            </b-row>
        </div>

        <!-- Paso 2: Confirmación de envío -->
        <div v-if="currentStep === 'submitted'" class="text-center py-3">
            <i class="fas fa-check-circle text-success" style="font-size: 2.5rem;"></i>
            <h5 class="mt-3">Solicitud en ejecución</h5>
            <p class="text-muted mb-1">{{ submittedMessage }}</p>
            <p class="text-muted" v-if="batchId">
                <small>Batch ID: {{ batchId }}</small>
            </p>
        </div>

        <template v-slot:modal-footer>
            <!-- Botones para paso de carga -->
            <div v-if="currentStep === 'upload'" class="d-flex w-100 justify-content-between">
                <b-button variant="secondary" @click.prevent="closeModal">
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    @click.prevent="submitExcel"
                    :disabled="!selectedFile || isLoading"
                >
                    <b-spinner small v-if="isLoading"></b-spinner>
                    {{ isLoading ? 'Enviando...' : 'Enviar Invitaciones' }}
                </b-button>
            </div>

            <!-- Botones para paso de confirmación -->
            <div v-if="currentStep === 'submitted'" class="d-flex w-100 justify-content-end">
                <b-button variant="primary" @click.prevent="closeModal">
                    Cerrar
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "BulkInvitationUploadModal",
    props: {
        modalVisible: {
            type: Boolean,
            required: true
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            currentStep: 'upload',
            selectedFile: null,
            submittedMessage: '',
            batchId: null,
        }
    },
    methods: {
        submitExcel() {
            if (!this.selectedFile) {
                this.showToast('Por favor seleccione un archivo Excel para subir', 'Error', 'danger');
                return;
            }

            this.$emit('update:isLoading', true);

            const formData = new FormData();
            formData.append('file', this.selectedFile);

            this.$conectar.post('/admin/chatbot-invitations/bulk', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                this.submittedMessage = response.data.message || 'La solicitud se está procesando en segundo plano.';
                this.batchId = response.data.batch_id || null;
                this.currentStep = 'submitted';
                this.$emit('update:isLoading', false);
            })
            .catch(error => {
                console.error('Error enviando archivo:', error);
                const errorMessage = error.response?.data?.message || 'Error al enviar el archivo';
                this.showToast(errorMessage, 'Error', 'danger');
                this.$emit('update:isLoading', false);
            });
        },

        resetState() {
            this.currentStep = 'upload';
            this.selectedFile = null;
            this.submittedMessage = '';
            this.batchId = null;
        },

        closeModal() {
            this.resetState();
            this.$emit('close-modal');
        },

        showToast(message, title, variant) {
            this.$bvToast.toast(message, {
                title: title,
                variant: variant,
                solid: true
            });
        }
    },
    watch: {
        modalVisible(newVal) {
            if (newVal) {
                this.resetState();
            }
        }
    }
};
</script>